import isNumber from 'lodash/isNumber';

import { SpaceBetweenWrapper } from './CheckboxFilterTree.styles';
import { LabelComponent } from './model';

export const ResponsiveLabel: LabelComponent = ({ title, count }) => (
    <SpaceBetweenWrapper>
        <span>{title}</span>
        <span>{count}</span>
    </SpaceBetweenWrapper>
);

export const TextLabel: LabelComponent = ({ title, count }) => (
    <>
        {title}&ensp;{isNumber(count) && <>({count})</>}
    </>
);
